import { render, staticRenderFns } from "./RefNumTag.vue?vue&type=template&id=f44c4ba2"
import script from "./RefNumTag.vue?vue&type=script&lang=js"
export * from "./RefNumTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports